import { _Apiauth } from "./api/_call";
export const isCurrentDomain = async (domainToCheck) => {
  const currentDomain = window.location.hostname;
  return currentDomain === domainToCheck;
};
// AuthMiddleware.js

/**
 * Save user token to localStorage with guaranteed completion
 * Returns a Promise that resolves only after token is saved and verified
 */

// export const setUserToken = (token) => {
//   localStorage.setItem("UserToken", token);
//   let myDoman = window.location.hostname;
//   localStorage.setItem("UserDomain", myDoman);
// };
export const setUserToken = (token) => {
  return new Promise((resolve, reject) => {
    try {
      // Clear old authentication data
      localStorage.removeItem("UserToken");
      localStorage.removeItem("UserDomain");
      
      // Set new token and domain
      localStorage.setItem("UserToken", token);
      localStorage.setItem("UserDomain", window.location.hostname);
      
      // Verify token was saved correctly
      const savedToken = localStorage.getItem("UserToken");
      const savedDomain = localStorage.getItem("UserDomain");
      
      if (savedToken === token && savedDomain === window.location.hostname) {
        console.log("✅ Token saved successfully");
        // Small delay to ensure browser completes the write
        setTimeout(() => {
          resolve(true);
        }, 10);
      } else {
        console.error("❌ Token save verification failed");
        reject(new Error("Failed to save token to localStorage"));
      }
    } catch (error) {
      console.error("❌ Error saving token:", error);
      reject(error);
    }
  });
};

export const getUserToken = async () => {
  if (localStorage.getItem("UserToken")) {
    let res = await _Apiauth(
      { authToken: localStorage.getItem("UserToken") },
      `authentication`
    );

    console.log(res,"reswhquwheuq")
    if (res?.code === 200) {
      return localStorage.getItem("UserToken");
    } else {
      return false;
    }
  } else {
    return false;
  }
};

// export const isAuthenticated = async () => {
//   const userToken = await getUserToken();
//   return !!userToken;
// };
export const isAuthenticated = async () => {
  await new Promise(resolve => setTimeout(resolve, 100)); // 1 sec delay
  const userToken = await getUserToken();
  return !!userToken;
};

export const logout = () => {
  localStorage.removeItem("UserToken");
  localStorage.removeItem('updateModulePermission');
  localStorage.removeItem('updateUserPermission');
};

export const authMiddleware = () => {
  return (props) => {
    if (!isAuthenticated()) {
      return null;
    }
    return true;
  };
};